import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';

interface IProfilesProps {
  heading: string;
  info: string;
}

export const ProfilesTableRow: React.FC<IProfilesProps> = ({ heading, info }) => {
  const styles = StyleSheet.create({
    info: {
      fontFamily: 'Noto',
      fontWeight: 300,
      color: '#000',
      fontSize: '9px',
      width: '221.09px',
    },
    rowWrap: {
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      padding: '5px 0 5px 0',
      borderBottom: '0.3px dotted #77787C',
      width: '100%',
    },
    heading: {
      fontFamily: 'Noto',
      fontWeight: 600,
      color: '#000',
      fontSize: '8px',
      width: '84px',
      marginRight: '20px',
      marginLeft: '2px',
    },
  });
  return (
    <View style={styles.rowWrap}>
      <Text style={styles.heading}>{heading}</Text>
      <Text style={styles.info}>{info}</Text>
    </View>
  );
};
